import permissions from '../../permissions'

const COMPLAINT_LIST = [
  {
    name: 'Listagem de denúncias',
    tag: permissions.COMPLAINTS.LIST,
  },
  {
    name: 'Visualizar denúncias',
    tag: permissions.COMPLAINTS.SHOW,
  },
  {
    name: 'Registrar responsável',
    tag: permissions.COMPLAINTS.REGISTER_RESPONSIBLE,
  },
  {
    name: 'Responder mensagem na denúncia',
    tag: permissions.COMPLAINT_MESSAGES.CREATE,
  },
  {
    name: 'Listar configurações de denúncias',
    tag: permissions.COMPLAINTS.LIST_CONFIGURATIONS,
  },
  {
    name: 'Gerenciar configurações de denúncias',
    tag: permissions.COMPLAINTS.MANAGE_CONFIGURATIONS,
  },
  {
    name: 'Ativar ou inativar canal de denúncia',
    tag: permissions.COMPLAINTS.ACTIVATE_COMPLAINTS,
  },
]

export default COMPLAINT_LIST
